import { round } from 'lodash'

function getQuoteTotals(quote, quoteInfo) {
	const grandTotal = 0
	const subTotal = 0
	const totalMarginAndOverhead = 0
	const totalMarginAndOverheadPercentage = 0
	const totalFrance = 0
	const totalInternational = 0
	const totalInternationalLocalCurrency = 0
	const reduceFinalObject = {
		totalFrance,
		totalInternational,
		totalInternationalLocalCurrency,
		totalMarginAndOverhead,
		subTotal,
		grandTotal,
		totalMarginAndOverheadPercentage,
	}
	if (quote && quoteInfo) {
		const finalObject = quoteInfo.reduce((finalObject, costLine) => {
			if (costLine.costLineType === 'costLine') {
				if (costLine.total) {
					if (!costLine.isInternational)
						finalObject.totalFrance += costLine.total
					if (costLine.isInternational)
						finalObject.totalInternational += costLine.total
					finalObject.subTotal += costLine.total
					finalObject.grandTotal += costLine.total
				}
				if (costLine.totalMargin) {
					finalObject.totalMarginAndOverhead += costLine.totalMargin
					finalObject.grandTotal += costLine.totalMargin
				}
			}
			return finalObject
		}, reduceFinalObject)
		if (
			quote?.discount?.totalAfterDiscount &&
			typeof quote.discount.totalAfterDiscount === 'number'
		) {
			finalObject.grandTotal = quote.discount.totalAfterDiscount
			finalObject.totalMarginAndOverhead =
				finalObject.grandTotal - finalObject.subTotal
		}
		if (finalObject.grandTotal)
			finalObject.totalMarginAndOverheadPercentage =
				(finalObject.totalMarginAndOverhead / finalObject.grandTotal) *
				100
		finalObject.totalInternationalLocalCurrency =
			finalObject.totalInternational / quote.exchangeRate
		for (const key in finalObject) {
			finalObject[key] = round(finalObject[key], 2)
		}
		return finalObject
	}

	return reduceFinalObject
}

export default getQuoteTotals
